import {WlDropdown} from "../../webcomponents/dropdown/dropdown.component";

export default class SerpSorting {

    public constructor(onSortingChange: () => void) {
        setTimeout(() => document.querySelector<WlDropdown>(".sort-button")?.addEventListener("wl-submit", onSortingChange), 10);
    }

}
